export const internalGlobalObjectKey = '_faroInternal';



// WEBPACK FOOTER //
// ../../../src/sdk/const.ts